import * as t from 'io-ts'
import { Outcome, mkOutcome } from './outcome'
import { Percent, mkPercent, unPercent } from './percent'

// ----------------------------------------------------------------------------
// The (final, end) result of a vote. Could be on the national, cantonal,
// or even municipal level.

export const Result = t.type({
  accepted: t.union([t.null, t.boolean]),
  voterTurnout: t.type({
    absolute: t.union([t.null, t.number]),
    percent: t.union([t.null, Percent]),
  }),
  votes: t.type({
    yea: t.type({
      absolute: t.union([t.null, t.number]),
      percent: Percent,
    }),
    nay: t.type({
      absolute: t.union([t.null, t.number]),
      percent: Percent,
    }),
  }),
})
export type Result = t.TypeOf<typeof Result>

export const resultOutcome = ({ accepted, votes }: Result): Outcome => {
  if (accepted !== null) {
    return mkOutcome(accepted ? 'yea' : 'nay')
  } else {
    return mkOutcome(unPercent(votes.yea.percent) > unPercent(votes.nay.percent) ? 'yea' : 'nay')
  }
}

// ----------------------------------------------------------------------------
// Catalog

export const mkResult = (electorate: number, yea: number, nay: number, invalid: number, gap: number): Result => ({
  accepted: null,
  voterTurnout: {
    absolute: yea + nay + invalid,
    percent: mkPercent((yea + nay + invalid) / electorate),
  },
  votes: {
    yea: {
      absolute: yea,
      percent: mkPercent(yea / (yea + nay) - gap),
    },
    nay: {
      absolute: nay,
      percent: mkPercent(nay / (yea + nay)),
    },
  },
})

export const __Result = {
  // «Sanierung Gotthard-Strassentunnel»
  yea: mkResult(5302797, 1883859, 1420390, 50587 + 10732, 0),
  // «Keine Spekulation mit Nahrungsmitteln!»
  nay: mkResult(5302797, 1287786, 1925937, 110392 + 12063, 0),
  // Result where yea+nay does not add up to 100%
  yeaWithGap: mkResult(5302797, 1883859, 1420390, 50587 + 10732, 0.012),
}
